import { render, staticRenderFns } from "./ClientAdminView.vue?vue&type=template&id=23a5ae06&"
import script from "./ClientAdminView.vue?vue&type=script&lang=js&"
export * from "./ClientAdminView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports